import connectToContext from '@slergberg/react-hoc-connect-to-context'

import PlayerContext from './PlayerContext'
import Timer from './Timer'

export default connectToContext(PlayerContext, (state) => ({
  duration: state.duration,
  position: state.seekingPosition,
}))(Timer)
